import React, { useState, useEffect } from 'react';

function ScrollToTopButton() {
    const [visible, setVisible] = useState(false);

    const handleScroll = () => {
        // Verifica a posição do scroll
        if (window.scrollY > window.innerHeight) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        // Adiciona um listener de scroll
        window.addEventListener('scroll', handleScroll);

        // Remove o listener de scroll ao desmontar o componente
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px', // Ajuste aqui para mover para a direita
                backgroundColor: 'transparent', // Defina uma cor de fundo
                color: '#04F56C',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                fontSize: '24px',
                cursor: 'pointer',
                opacity: visible ? 1 : 0,
                visibility: visible ? 'visible' : 'hidden',
                transition: 'opacity 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0', // Remove qualquer padding extra
                
            }}
            onClick={scrollToTop}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" className="arrow" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-7.5 3.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z" />
            </svg>
        </button>
    );
}

export default ScrollToTopButton;
